import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import Layout from "../Common/Layout";
import build from "redux-object";
import { addUser } from "../../actions/user.actions";
import UserForm from "./UserForm";
import AppLink from "../Common/AppLink";

export class CreateUser extends PureComponent {
  onSubmit = data => {
    this.props.dispatch(addUser(data));
  };

  render() {
    const { currentUser, tenants } = this.props;

    if (!currentUser || currentUser.admin !== true) {
      return (
        <Layout.Page>
          <Layout.Header title="Admin" />
          <Layout.Content>
            <p>You don't have the expected credentials to see this page.</p>
          </Layout.Content>
        </Layout.Page>
      );
    }
    return (
      <Layout.Page>
        <Layout.Header
          link={<AppLink ellipsis={false} icon="angle left" content="Back" to="/users" size="large" />}
          title="Add User"
        />
        <Layout.Content>
          <UserForm tenants={tenants} onSubmit={this.onSubmit} edit={false}></UserForm>
        </Layout.Content>
      </Layout.Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  currentUser: get(state, "common.currentUser"),
  tenants: build(state.common, "tenants", null, { ignoreLinks: true }),
  tenantSlug: get(state, "common.currentTenant.slug")
});
export default connect(mapStateToProps)(CreateUser);
